// extracted by mini-css-extract-plugin
export default {"container":"EmptyChatList__container___GyzCi","containerV2":"EmptyChatList__containerV2___Tj1fk"};